(function () {
  'use strict';

  function setup(wrapEl) {
    if (!wrapEl || wrapEl._carouselBound) return;
    wrapEl._carouselBound = true;

    var btnPrev = wrapEl.querySelector('[data-carousel-prev]');
    var btnNext = wrapEl.querySelector('[data-carousel-next]');
    if (!btnPrev || !btnNext) return;

    function getTrack() {
      return wrapEl.querySelector('[data-carousel-track]');
    }

    function getIdx() {
      var track = getTrack();
      var first = track && track.children[0];
      if (!first || !first.offsetWidth) return 0;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return Math.round(track.scrollLeft / (first.offsetWidth + gap));
    }

    function goTo(n) {
      var track = getTrack();
      if (!track) return;
      var total = track.children.length;
      var target = ((n % total) + total) % total;
      var first = track.children[0];
      if (!first) return;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var itemW = first.offsetWidth + gap;
      var targetScroll = target * itemW;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (targetScroll > maxScroll) {
        targetScroll = n >= 0 ? 0 : maxScroll;
      }
      track.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }

    function updateArrows() {
      var track = getTrack();
      var hasOverflow = track && track.children.length > 0 && track.scrollWidth > track.clientWidth + 1;
      btnPrev.style.display = hasOverflow ? '' : 'none';
      btnNext.style.display = hasOverflow ? '' : 'none';
    }

    btnPrev.addEventListener('click', function () { goTo(getIdx() - 1); });
    btnNext.addEventListener('click', function () { goTo(getIdx() + 1); });

    requestAnimationFrame(function () { requestAnimationFrame(updateArrows); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 150);
    });

    var rec = wrapEl.querySelector('product-recommendations');
    if (rec) {
      new MutationObserver(function () {
        requestAnimationFrame(function () { requestAnimationFrame(updateArrows); });
      }).observe(rec, { childList: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-carousel-wrap]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('[data-carousel-wrap]').forEach(function (wrap) {
      wrap._carouselBound = false;
      setup(wrap);
    });
  });
})();
